import {LocalizationProvider} from '@mui/x-date-pickers'
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment'
import {ReactNode} from 'react'

export const withLocalisation = (component: () => ReactNode) => () => (
  <LocalizationProvider dateAdapter={AdapterMoment}>{component()}</LocalizationProvider>
)
